import api from '@/services/utils/base';

export default class Dictionary {
  get(dictionary: string, params: any = {}) {
    return api.get(`dictionaries/${dictionary}`, { params })
      .then((res: any) => Promise.resolve(res.data.payload))
      .catch((err: any) => Promise.reject(err))
  }

  validate(dictionary: string, list: []) {
    return api.post(`dictionaries/${dictionary}`, { name: list })
      .then((res: any) => Promise.resolve(res.data.payload))
      .catch((err: any) => Promise.reject(err));
  }
}
